import { useEffect, useState } from 'react';

const withDateInView = WrappedComponent => {
  return ({ dateInView, ...props }) => {
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
      setShouldRender(false);
      setTimeout(() => {
        setShouldRender(true);
      }, 1);
    }, [dateInView]);

    if (!shouldRender) return null;

    return (
      <WrappedComponent initialVisibleMonth={() => dateInView} {...props} />
    );
  };
};

export default withDateInView;
